import React from 'react'

export default function WizardNavbar() {
  return (
    <div className='stepper-nav mb-17'>
      <div className='stepper-item current' data-kt-stepper-element='nav'>
        <h3 className='stepper-title'>Datos del pago</h3>
      </div>

      <div className='stepper-item' data-kt-stepper-element='nav'>
        <h3 className='stepper-title'>Confirmar datos</h3>
      </div>

      <div className='stepper-item' data-kt-stepper-element='nav'>
        <h3 className='stepper-title'>Completado</h3>
      </div>
    </div>
  )
}
